import {ArrayTogglerBehaviorTypes} from '../../../hooks/useArrayToggler';

// keeping key names same as hermes request for ease of lookup
export const fixedFilters = {
  step_range: {
    name: 'step_range',
    type: ArrayTogglerBehaviorTypes.multiSelect,
    data: [
      {name: 'Upto ₹2000', key: {min: 0, max: 2000}},
      {name: '₹2001 - ₹4000', key: {min: 2001, max: 4000}},
      {name: '₹4001 - ₹6000', key: {min: 4001, max: 6000}},
      {name: '₹6001 - ₹8000', key: {min: 6001, max: 8000}},
      {name: '₹8000 +', key: {min: 8000, max: 8000}},
    ],
  },
  star: {
    name: 'star',
    type: ArrayTogglerBehaviorTypes.multiSelect,
    data: [
      {name: '5 star', key: 5},
      {name: '4 star', key: 4},
      {name: '3 star', key: 3},
      {name: '2 star', key: 2},
      {name: '1 star', key: 1},
    ],
  },
  range_ugc: {
    name: 'range_ugc',
    type: ArrayTogglerBehaviorTypes.singleSelect,
    data: [
      {name: '4+', key: [4, 5]},
      {name: '3.5+', key: [3.5, 5]},
      {name: '3+', key: [3, 5]},
    ],
  },
};

// Type as generic util
export const findFixedFilter = ({target, src, type}) => {
  const result = src.find(srcItem => {
    if (type === 'step_range') {
      return `${type}${srcItem.key.min}` === `${type}${target.min}`;
    }
    if (type === 'star') {
      return `${type}${srcItem.key}` === `${type}${target}`;
    }
    if (type === 'range_ugc') {
      return `${type}${srcItem.key[0]}` === `${type}${target[0]}`;
    }
    return false;
  });
  return result;
};

export function getFilterCategoryForHermesDataList(
  data: Array<{n: string; fd: {(key: string): any}}>,
): string {
  return Object.keys(data.find(item => item.fd && Object.keys(item.fd).length > 0)?.fd)[0];
}

export function updateFilterForSingleSelection(filterDictForItemUnderAction, appliedFilters) {
  const newAppliedFilterObj = {...appliedFilters};

  const filterKeyFromItemUnderAction = Object.keys(filterDictForItemUnderAction)[0];
  const filterValueFromItemUnderAction = filterDictForItemUnderAction[filterKeyFromItemUnderAction];

  const filterKeyToBeOperatedOn = Object.keys(appliedFilters)
    .map(appliedFilterKey => appliedFilterKey)
    .find(item => item === Object.keys(filterDictForItemUnderAction)[0]);

  if (!filterKeyToBeOperatedOn) {
    newAppliedFilterObj[filterKeyFromItemUnderAction] = filterValueFromItemUnderAction;
    return newAppliedFilterObj;
  }

  if (Array.isArray(newAppliedFilterObj[filterKeyFromItemUnderAction])) {
    const filterAlreadyHasItem = newAppliedFilterObj[filterKeyFromItemUnderAction].find(
      item => item.loc_id && filterValueFromItemUnderAction[0].loc_id === item.loc_id,
    );

    if (filterAlreadyHasItem) {
      newAppliedFilterObj[filterKeyFromItemUnderAction] = newAppliedFilterObj[
        filterKeyFromItemUnderAction
      ].filter(item => item.loc_id && item.loc_id !== filterAlreadyHasItem.loc_id);
    } else {
      newAppliedFilterObj[filterKeyFromItemUnderAction].push(filterValueFromItemUnderAction[0]);
    }
  } else {
    newAppliedFilterObj[filterKeyFromItemUnderAction] =
      newAppliedFilterObj[filterKeyFromItemUnderAction] === 0 ? 1 : 0;
  }

  return newAppliedFilterObj;
}

export const fixedPopularFilter = {
  fc: 'Free Cancellation',
  pah: 'Pay At Hotel',
  fbfi: 'Free Breakfast',
  ibf: 'Free Breakfast',
  gs: 'MySafety'
};
